import { SystemSelectorCustomerType } from 'data/types';

export const formatSubmittedAt = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
};

export const formatProjectType = (projectType: string | null): string => {
  if (!projectType) {
    return '—';
  }
  const spaced = projectType.replace(/([A-Z])/g, ' $1').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const customerMatchesSearch = (
  customer: SystemSelectorCustomerType,
  query: string
): boolean => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) {
    return true;
  }
  const haystack = [
    customer.name,
    customer.email,
    customer.phone ?? '',
    customer.projectType ?? '',
    customer.homeAddress ?? '',
    customer.projectGoals ?? '',
    customer.unusualNotes ?? ''
  ]
    .join(' ')
    .toLowerCase();
  return haystack.includes(trimmed);
};
